import {
  WorkPackageSearchByTerm,
  WorkPackageSearchByEnum,
  WorkPackageSortByTerm,
  WorkPackageFilterByTerm,
  MilestoneFilterStatusFlag,
} from '@bechtel/types';
import { t } from '@lingui/macro';

export enum SortDirection {
  ASC = 'ASC',
  DESC = 'DESC',
}

export interface DrawerValuesProps {
  searchBy: WorkPackageSearchByTerm[];
  filterBy: string;
  sortBy: string;
  sortDir: SortDirection;
  searchScope: boolean;
}

export const drawerValues: DrawerValuesProps = {
  searchBy: [{ type: WorkPackageSearchByEnum.WP_NUMBER }],
  filterBy: WorkPackageFilterByTerm.ALL,
  searchScope: true,
  sortBy: WorkPackageSortByTerm.WP_NUMBER,
  sortDir: SortDirection.DESC,
};

export const filterByList = [
  { id: 0, value: WorkPackageFilterByTerm.ALL, label: t`All` },
  { id: 1, value: WorkPackageFilterByTerm.ACTIVE, label: t`Active` },
  { id: 2, value: WorkPackageFilterByTerm.IN_3WLA, label: t`In 3WLA` },
  { id: 3, value: WorkPackageFilterByTerm.COMPLETED, label: t`Completed` },
  { id: 4, value: MilestoneFilterStatusFlag.READY_TO_CLAIM_CONNECTIONS, label: t`Ready to claim` },
  { id: 5, value: MilestoneFilterStatusFlag.PENDING_APPROVAL, label: t`Pending Approval` },
  { id: 6, value: MilestoneFilterStatusFlag.REJECTED, label: t`Rejected` },
];

export const sortByList = [
  { id: 1, value: WorkPackageSortByTerm.WP_NUMBER, label: t`Work Package` },
  { id: 2, value: WorkPackageSortByTerm.START_DATE, label: t`Start Date` },
  { id: 3, value: WorkPackageSortByTerm.END_DATE, label: t`End Date` },
  { id: 4, value: WorkPackageSortByTerm.PERCENTAGE_COMPLETE, label: t`Percent Complete` },
];

export const searchScopeList = [
  { id: 1, value: true, label: t`Assigned to Me` },
  { id: 2, value: false, label: t`All Workpackages` },
];

export const searchByList = [
  {
    searchByTerm: { type: WorkPackageSearchByEnum.WP_NUMBER },
    label: t`Work Package Number`,
    scope: [true, false],
  },
  {
    searchByTerm: { type: WorkPackageSearchByEnum.COMMODITY },
    label: t`Commodity Tag`,
    scope: [true, false],
  },
  {
    searchByTerm: { type: WorkPackageSearchByEnum.STARTUP_SYSTEM_NUMBER },
    label: t`Startup System Number`,
    scope: [true, false],
  },
  {
    searchByTerm: { type: WorkPackageSearchByEnum.AREA_NUMBER },
    label: t`Area Number`,
    scope: [true, false],
  },
  { searchByTerm: { type: WorkPackageSearchByEnum.PERSONA }, label: t`User Name`, scope: [true, false] },
];
